import { createContext } from "react";

const CursosContext = createContext();

export default CursosContext;
